import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { DeleteEquipmentModalT } from './delete-equipment-modal.types';
import { Loader } from 'lucide-react';
import { useParams } from 'react-router-dom';
import useDeleteEquipment from '@/hooks/queries/equipments-api/useDeleteEquipment';

const DeleteEquipmentModal = ({
  open,
  onOpenChange
}: DeleteEquipmentModalT) => {
  const { t } = useTranslation();
  const { id: equipmentId } = useParams();
  const { mutate, isPending } = useDeleteEquipment();

  const handleDelete = () => {
    if (equipmentId !== undefined) mutate(equipmentId);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('modals.alert.title')}</DialogTitle>
          <DialogDescription>
            {t('modals.alert.deleteEquipment')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t('modals.alert.close')}</Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isPending}
          >
            {isPending ? (
              <Loader className="w-4 h-4 animate-spin" />
            ) : (
              t('modals.alert.delete')
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteEquipmentModal;
